import { render, staticRenderFns } from "./EmailsListEdit.vue?vue&type=template&id=304117d5&"
import script from "./EmailsListEdit.vue?vue&type=script&lang=ts&"
export * from "./EmailsListEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports